const ODAL_REGEX = /ODAL_\d{8}_\d+\.csv/
const ZAIGAI_REGEX =
  /ZAIGAI_TOKOUSHA_\d{8}_\d{6}\.csv|ZAIGAI_TOKOUYOTEI_\d{8}_\d{6}\.csv/
const SHINHAKEN_REGEX =
  /SHINHAKEN_TOKOUSHA_\d{14}\.csv|SHINHAKEN_TOKOUYOTEI_\d{14}\.csv/
const VOL_REGEX = /VOL_TOKOUSHA_\d{14}\.csv|VOL_TOKOUYOTEI_\d{14}\.csv/
const VOL_SHINHAKEN_ZAIGAI_REGEX = /VOL|SHINHAKEN|ZAIGAI/

const SYSTEM_LENGTH = {
  ODAL_SYSTEM_LENGTH: 74,
  TOKOUSHA_SYSTEM_LENGTH: 55,
  TOKOUYOTEI_SYSTEM_LENGTH: 54,
}

const SYSTEM_NAMES = {
  ERROR_SYSTEM_LENGTH:
    "アップロードされたファイルのフォーマットが不正です。再度ご確認ください。 項目数:「{0}」",
  FILE_TYPE_NAME: "再度ご確認ください。項目数: csv",
  IDM_NAME: "IDMシステム",
  INVALID_NAME: "該当するシステムがありません",
  SHINHAKEN_NAME: "新派遣システム",
  VOL_NAME: "ボランティアシステム",
  ZAIGAI_NAME: "在外職員システム",
}

const SYSTEM_IDS = {
  IDM: "1",
  INVALID: "0",
  SHINHAKEN: "3",
  VOL: "4",
  ZAIGAI: "2",
}

export const Variables = {
  ODAL_REGEX,
  SHINHAKEN_REGEX,
  SYSTEM_IDS,
  SYSTEM_LENGTH,
  SYSTEM_NAMES,
  VOL_REGEX,
  VOL_SHINHAKEN_ZAIGAI_REGEX,
  ZAIGAI_REGEX,
}
